import React from 'react'
import '../styles/Footer.css';
const Footer = () => {
  return (
      <div className="footer">
          <p style={{color: 'white'}}> &copy; 2022 Tamara Ackovska</p>
          </div>
  )
}

export default Footer